/*
	  $$$\                                                                                             $$$\   
	 $$  _|                                                                                            \_$$\  
	 $$ |         $$$$$$\   $$$$$$\   $$$$$$$\  $$$$$$\  $$\   $$\  $$$$$$$\  $$$$$$\   $$$$$$$\         $$ | 
	$$$ |        $$  __$$\ $$  __$$\ $$  _____|$$  __$$\ $$ |  $$ |$$  _____|$$  __$$\ $$  _____|        $$$\ 
	\$$ |        $$ |  \__|$$$$$$$$ |\$$$$$$\  $$ /  $$ |$$ |  $$ |$$ /      $$$$$$$$ |\$$$$$$\          $$  |
	 $$ |        $$ |      $$   ____| \____$$\ $$ |  $$ |$$ |  $$ |$$ |      $$   ____| \____$$\         $$ / 
	 \$$$\       $$ |      \$$$$$$$\ $$$$$$$  |\$$$$$$  |\$$$$$$  |\$$$$$$$\ \$$$$$$$\ $$$$$$$  |      $$$  | 
	  \___|      \__|       \_______|\_______/  \______/  \______/  \_______| \_______|\_______/       \___/  
	                                                                                                          
	                                                                                                          
	                                                                                                          
*/

(function(angular){
	'use strict';

	//var googleSpreadsheet = "//spreadsheets.google.com/feeds/list/1mwFpK3Fj929aK0PfzmscJKGjAfgcdUYsEu-ikI8z6RM/od6/public/basic?alt=json";
	var googleSpreadsheet = '//spreadsheets.google.com/feeds/list/1mwFpK3Fj929aK0PfzmscJKGjAfgcdUYsEu-ikI8z6RM/od6/public/values?alt=json-in-script&callback=JSON_CALLBACK';
	var localDb = '/db/organizations.json';
	var host = 'http://map.api.hhv.or.kr:3000';	

	function responseToMessage(data, headersGetter){
				if(typeof data === 'object')
					return data;
				var modifiedData = {};
				modifiedData.message = data;
				return modifiedData;
			}

	function stripArray(data, headersGetter){
		if(Array.isArray(data) && data.length == 1)
			data = data[0];
		return data;
	}

	angular.module('hhv.db', ['ngResource', 'ngCookies', 'toaster'])
		.config(['$httpProvider', function HhvDbConfig($httpProvider){
			$httpProvider.interceptors.push('HvNotificationInterceptor');
			 $httpProvider.interceptors.push('HvCredentialInterceptor');
		}])
		.run(['$rootScope','$http', '$cookies', 'HvUser', function($rootScope, $http, $cookies, HvUser){
			
		}])
		.factory('HvNotificationInterceptor', ['$log', '$q', '$rootScope', function HvNotificationInterceptor($log, $q, $rootScope){
			return {
				response: notificationResponse,
				responseError: notificationResponseError
			};

			function notificationResponse(response){
				$rootScope.$broadcast('$http.response', response);
				$log.debug(response);
				return response;
			}

			function notificationResponseError(rejection){
				$rootScope.$broadcast('$http.rejection', rejection);
				return $q.reject(rejection);
			}
		}])
		/* 
			Automatically get/set access-token with config.url is from host
		 */
		.factory('HvCredentialInterceptor', ['$log', '$cookies', '$q', function HvCredentialInterceptor($log, $cookies, $q){
			return {
				request: credentialRequest,
				response: credentialResponse,
				responseError: credentialResponseError
			};

			function credentialRequest(config){
				if(config.url.indexOf(host)<0) //Handle only on api host
					return config;
				var accessToken = $cookies.get('access-token');
				var accessId = $cookies.get('access-id');
				if(accessToken && accessId)
					config.headers['access-token'] = accessToken;
				return config;
			}

			function credentialResponse(response){
				if(response.config.url.indexOf(host)<0) //Handle only on api host
					return response;
				var headers = response.headers();
				var accessToken = headers['access-token'];
				var accessId = headers['access-id'];
				if(accessToken)
					$cookies.put('access-token', accessToken);
				if(accessId)
					$cookies.put('access-id', accessId);
				return response;
			}
			//TODO 	@ref http://espeo.eu/blog/authentication-in-angularjs-or-similar-based-application/
			function credentialResponseError(rejection){
				if(rejection.config.url.indexOf(host)<0 ||//Handle only on api host
				   rejection.status !== 401)  			 //Handle only Unathorized
					return $q.reject(rejection);
				return $q.reject(rejection);
			}
		}])
		.factory('HvUser', ['$log', '$rootScope', '$cookies', '$timeout', 'HvPerson', 'toaster', function HvUser($log, $rootScope, $cookies, $timeout, HvPerson, toaster){
			var accessToken = $cookies.get('access-token');
			var accessId = $cookies.get('access-id');
			var currentUser = new HvPerson();

			if(accessToken && accessId){
				currentUser.id = accessId;
				currentUser.$get(function success(){
					currentUser.valid = true;
				}, function failed(){
					logout();
				});
			}else if(accessToken || accessId){
				$cookies.remove('access-token');
				$cookies.remove('access-id');
			}

			var service = {
				get resource(){
					return currentUser;
				},
				get name(){
					return currentUser.name;
				},
				get email(){
					return currentUser.email;
				},
				get id(){
					return currentUser.id || $cookies.get('access-id');
				},
				get level(){
					return currentUser.level;
				},
				isAvailable : function(){
					var accessToken = $cookies.get('access-token');
					var accessId = $cookies.get('access-id');
					return !!accessToken && !!accessId;
				},
				isLogin : function(){
					return !!currentUser.valid;
				},
				isAdmin : function(){
					return currentUser.level == 1;
				}
			};
			service.login = login;
			service.logout = logout;
			service.register = register;
			service.update = update;
			service.findPassword = findPassword;
			service.person = currentUser;
			return service;

			function login(user, callSuccess, callFailed){
				service.response = HvPerson.login(
					user,
					function success(value, getResponseHeaders) { //success	
					  delete user.passwd; //remove password after use for security;

  					$log.debug(value, getResponseHeaders());
						var headers = getResponseHeaders();
						accessId = value.id;
						$cookies.put('access-id', accessId);

						currentUser.id = accessId;
						currentUser.$get(function(value, getResponseHeaders){
							currentUser.valid = true;
							if(typeof callSuccess === 'function')
								callSuccess(value, getResponseHeaders);
							toaster.success({
								title: '로그인',
								body: value.name + '님 안녕하세요?'
							});
						});
					},
					function failed(httpResponse){
						delete user.passwd; //remove password after use for security;
						$log.warn('login failed', httpResponse);
						httpResponse.msg = httpResponse.data;
						angular.extend(service.response, httpResponse);
						if(typeof callFailed === 'function')
							callFailed(httpResponse);
						toaster.warning({
							title: '로그인 실패',
							body: httpResponse.msg,
						});
					});
				return service.response;
			}

			function logout(success, failed){
				$timeout(function(){
					try {
						$cookies.remove('access-token');
						$cookies.remove('access-id');
						delete currentUser.valid;
						currentUser = new HvPerson();
						if(currentUser.id) throw 'User is still available';
						if(typeof success === 'function') success();
						toaster.info({
							title: '로그아웃',
							body: '안전하게 로그아웃 되었습니다.'
						});
					} catch(error){
						$log.warn(error);
						if(typeof failed === 'function') failed(error);
						toaster.error({
							title: '로그아웃 실패',
							body: error,
							timeout: 0
						});
					}
				},0);
			}

			function register(user, success, failed){
				service.response = HvPerson.save(
					user,
					function(value, getResponseHeaders){ //success
						if(typeof success === 'function')
							success(value, getResponseHeaders);
						toaster.success({
							title: '가입완료',
							body: user.name + '님 환영합니다!'
						});
					},
					function(httpResponse){
						$log.warn(httpResponse);
						if(typeof failed === 'function')
							failed(httpResponse);
						toaster.error({
							title: '회원가입 실패',
							//body: httpResponse,
						});
					});
				return service.response;
			}

			function update(user, success, failed){
				service.response = HvPerson.update(
					user,
					function(value, getResponseHeaders){ //success
						if(typeof success === 'function')
							success(value, getResponseHeaders);
					},
					function(httpResponse){
						$log.warn(httpResponse);
						if(typeof failed === 'function')
							failed(httpResponse);
					});
				return service.response;
			}

			function findPassword(email, success, failed){
				var data = email;
				if(typeof email == 'string')
					data = { email: email };
				service.response = HvPerson.findPassword(
					data, 
					function(value, getResponseHeaders){
						if(typeof success === 'function')
							success(value, getResponseHeaders);
					},
					function(httpResponse){
						$log.warn(httpResponse);
						if(typeof failed === 'function')
							failed(httpResponse);
					});
				return service.response;
			}
		}])
		.factory('HvPerson', ['$resource', '$http', '$cookies', function HvPerson($resource, $http, $cookies){			
			return $resource(host+'/users/:id', {id: '@id'}, {
				get: {method: 'GET', transformResponse: $http.defaults.transformResponse.concat(stripArray)},
				list: {method: 'GET', isArray: true},
				search: {method: 'GET', query: {query: '@query'}, isArray: true},
				save: {method: 'POST', transformResponse: responseToMessage},
				update: {method: 'PUT'},
				login: {method: 'POST', url: host+'/login', transformResponse: $http.defaults.transformResponse.concat(stripArray)},
				findPassword: {method: 'POST', url: host+'/findpw/'}
			});
		}])
		.factory('HvItem', ['$resource', '$http', 'HvUser', function HvItem($resource, $http, HvUser){
			var HvItemClass = $resource(host+'/items/', {}, {
				get: {mehod: 'GET', url: host+'/items/:id', params:{id: '@id', query: '@query'}}, 
				list: {method: 'GET'}, 
				update: {method: 'PUT', url: host+'/items/:id', params: {id: '@id'}, transformRequest: $http.defaults.transformRequest.concat(function(data, headersGetter){
					return data;
				})},
				search: {method: 'GET', params:{query: '@query', start: '@start', limit: '@limit', order: '@order', sort: '@sort'}}, 
				myItems: {method: 'GET', url: host+'/myitems', params:{query: '@query', start: '@start', limit: '@limit', order: '@order', sort: '@sort'}, isArray: true},
				delete: {method: 'DELETE', url: host+'/items/:id', params:{id: '@id'}}
			});

			HvItemClass.prototype.isEditable = function(first_argument) {
				return HvUser.isAdmin() || HvUser.id === this.user_id;
			};

			return HvItemClass;
		}])
		.factory('HvTag', ['$resource', function HvTag($resource){
			return $resource(host+'/tags/:id', {id: '@id', start: '@start', limit: '@limit', order: '@order', sort:'@sort'}, {
				list: {method: 'GET', isArray: true},
				search: {mehod: 'GET', params:{query: '@query'}, isArray:true}
			});
		}])
		.factory('HvList', ['$resource', '$http', 'HvItem', function HvList($resource, $http, HvItem){
			return $resource(host+'/lists/', {}, {
				list: {method: 'GET', isArray: true, transformResponse: function(data){
					data = angular.fromJson(data);
					for (var i = data.length - 1; i >= 0; i--) {
						var list = data[i];
						for (var j = list.items.length - 1; j >= 0; j--) {
							list.items[j] = new HvItem(list.items[j]);
						}
					}
					return data;
				}}, 
				search: {mehod: 'GET', params:{query: '@query', start: '@start', limit: '@limit', order: '@order', sort: '@sort'}, isArray: true}, 
			});
		}])
		.factory('HvDb', ['$q', '$log', 'HvItem', 'HvTag', 'HvPerson', 'HvList', function HvDb($q, $log, HvItem, HvTag, HvPerson, HvList){
			var db = {};
			db.search = search;
			db.orgs = [];
			db.items = new HvItem();
			db.itemsMap = {};
			db.tags = HvTag.list({order:'strength'}).$promise.then(function(data){
				angular.extend(db.tags, data);
			});
			db.items.$list(function success(response, headersGetter){angular.extend(db.items, mapItems(response.items));});
			db.selectedItems = [];
			db.selectItem = selectItem;
			db.deselectItems = deselectItems;
			db.getMyItems = getMyItems;
			return db;

			function search(queryString){
				var promise = $q(function(resolve, reject){
					HvItem.search({query: queryString}, function success(response, getResponseHeaders){
						var mappedItems = mapItems(response.items);
						promise.results = mappedItems;
						resolve(mappedItems);
					},
					function failed(httpResponse){
						$log.warn(httpResponse);
						reject(httpResponse);
						promise.results = [];
						promise.msg = httpResponse.data;
					});
				});
				return promise;
			}

			function selectItem(org){
				var options = {};
				if(Number(org))
					options.id = org;
				else {
					options.query = org.replace(/(^@|org:)/, '');
				}
				HvItem.get(options, function success(org){
					var mappedItems = mapItems([org]);
					for (var i in mappedItems){
						var org = mappedItems[i];
						org.selected = true;
						db.selectedItems.push(org);
					}
					return mappedItems;
				});
			}
			function deselectItems(orgNames){
				if(orgNames && !Array.isArray(orgNames))
					orgNames = [orgNames];
				for (var i in db.selectedItems){
					var org = db.selectedItems[i];
					if(orgNames && orgNames.length>0)
						for (var j = orgNames.length - 1; j >= 0; j--) {
							var orgName = orgNames[j];
							if(org.name !== orgName)
								continue; //No Match
							db.selectedItems.splice(i,1);
						}
					else if(!org || typeof org.selected === 'undefined') 
						continue; //Not defined
					delete org.selected;
				}
				if(!orgNames)
					db.selectedItems = [];
			}

			function mapItems(items, headersGetter){
				var mappedItems = [];
				for (var i in items) {
					var org = items[i];
					if(!org.id)
						continue;
					if(!db.itemsMap[org.id]){ //new org
						org = new HvItem(org);
						db.itemsMap[org.id] = org;
						db.orgs.push(org);
					}else{ //existing org
						angular.extend(db.itemsMap[org.id], org);							
						org = db.itemsMap[org.id];
					}
					mappedItems.push(org);
				}
				return mappedItems;
			}

			function getMyItems(){
				var promise = $q(function(resolve, reject){
					HvItem.myItems({}, function success(orgs, getResponseHeaders){
						var mappedItems = mapItems(orgs);
						promise.results = mappedItems;
						resolve(mappedItems);
					},
					function failed(httpResponse){
						$log.warn(httpResponse.data);
						reject(httpResponse);
						promise.results = [];
						promise.msg = httpResponse.data;
					});
				});
				return promise;
			}
		}])
		.service('db', ['$http', '$filter', '$sce', '$log', function($http, $filter, $sce, $log){
			var _organizationsMap = {};
			var $scope = {};
			$scope.status = '';
			$scope.tags = {};
			$scope.featuredTags = {};
			$scope.searchResponse = {};
			$scope.organizations = [];
			$scope.lastResult = [];

			$scope.getTags = function(options) {
				return $filter('orderObjectBy')($scope.tags, 'score', true);
			};

			$scope.countItems = function(options) {
				return $scope.organizations.length;
			};

			$scope.getItems = function(userOptions) {
				if(!userOptions) userOptions = {};
				var options = {
					limit: userOptions.limit 	|| 0,
					offset: userOptions.offset 	|| 0,
					select: userOptions.select 	|| '.*',
					roi: userOptions.roi 		|| null,	
															// {
															// 	northEast: [null, null],
															// 	southWest: [null, null]
															// },
					query: userOptions.query 	|| '',
					type: userOptions.type 		|| 'organization',
					tag: userOptions.tag 		|| ''
				};

				var hashCode = (JSON.stringify(options).hashCode() >>> 0).toString(16);

				if($scope.searchResponse[hashCode]){
					options = $scope.searchResponse[hashCode];
					$scope.lastResult = options.results;
					$log.debug('Returning cached', options);

					if(userOptions.success){
						userOptions.success(options.results);
					}

					return options;
				}else 
					$scope.searchResponse[hashCode] = options;

				$log.debug('Searching...', options);
				options.isSearching = true;
				options.results = [];

				var q = {
					tags: [],
					names: [],
					others: []
				};
				var queryString = options.query;
				var regTag = /(?:#|tag:)([^#@$\s:]+)/g;
				var regName = /(?:@|$|org:)([^#@$\s:]+)/g;
				var regOther = /(?:^|\s|:)([^#@$\s:]+)/g;
				var match;
				while ((match = regTag.exec(queryString)) !== null) {
					queryString = queryString.replace(match[0], '');
					q.tags.push(match[1]);
				}
				while ((match = regName.exec(queryString)) !== null) {
					queryString = queryString.replace(match[0], '');
					q.names.push(match[1]);
				}
				while ((match = regOther.exec(queryString)) !== null) {
					q.others.push(match[1]);
				}
				$http.jsonp(googleSpreadsheet)
				//$http.get(localDb)
					.then(function(response) {
						var orgs = [];
						var entry = response.data.feed.entry;
						for(var key in entry){
							var value = entry[key];
							//console.log(value);
							var json = '{ '+ value.content.$t.replace(/({|,)?\s*'?([A-Za-z_$\.][A-Za-z0-9_ \-\.$]*)'?\s*:\s+/g, '"$1 "$2": "').substr(1)+'" }';
							try {
								var org = JSON.parse(json);

								if(!_organizationsMap[org.id]){
									_organizationsMap[org.id] = org;
									$scope.organizations.push(org);

									if(org.tags){
										var ts = org.tags.split(/\s*,\s*/);
										org.tags = {};
										for (var i = ts.length - 1; i >= 0; i--) {
											var tagName = ts[i];
											if($scope.tags[tagName])
												$scope.tags[tagName].score++;
											else
												$scope.tags[tagName] = {name: tagName, score:1};
											org.tags[tagName] = $scope.tags[tagName];
										}
									}else{
										org.tags = {};
									}

								}else{
									if(org.tags) 
										delete org.tags;
									$.extend(_organizationsMap[org.id], org);							
									org = _organizationsMap[org.id];
								}
								
								org.score = -1;

								for(var nameKey in q.names){
									var nameToSearch = q.names[nameKey];
									if(org.name.indexOf(nameToSearch)>=0)
										org.score += 10;
								}

								for(var tagKey in org.tags){
									var tagToSearch = org.tags[tagKey];
									if(q.tags.indexOf(tagToSearch.name)>=0)
										org.score += 5;
								}

								for(var otherKey in q.others){
									var otherToSearch = q.others[otherKey];
									if(org.name && org.name.indexOf(otherToSearch)>=0)
										org.score += 3;
									if(org.brief && org.brief.indexOf(otherToSearch)>=0)
										org.score += 1.5;
									if(org.detail && org.detail.indexOf(otherToSearch)>=0)
										org.score += 1;
								}
								
								if(!options.query || org.score>=0)
									orgs.push(org);

							}catch(err){
								$log.error(err, org, json);
							}
						}
						
						orgs = $filter('orderBy')(orgs, '-score');

						if(options.limit > 0)
							orgs = orgs.slice(options.offset, options.offset + options.limit);

						$scope.lastResult = options.results = orgs;

						options.isSearching = false;

						$log.debug('Result ', options);

						if(userOptions.success){
							userOptions.success(options.results);
						}

						$scope.status = 'done';
					},
					function(response) {
						$log.error(response);
					});
				return $scope.searchResponse[hashCode];
			};

			$scope.getItems({success: function (results){
				//_organizationsMap = results;
			}});
			return $scope;
		}]);
})(angular);